import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { FtlShipnowComponent } from '../../../../app/full-truck-load/ftl-shipnow/ftl-shipnow.component';

@Component({
  selector: 'app-new-bidsettings-popup',
  templateUrl: './new-bidsettings-popup.component.html',
  styleUrls: ['./new-bidsettings-popup.component.scss']
})
export class NewBidsettingsPopupComponent implements OnInit {
  
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() startTimer = new EventEmitter<void>();
  @Input() Orderid: any;

  MinBidAmount: any;
  BidDurationData: any;
  MaxBidAllowance: number = 0;//added by BURHAN - 28-April-2026

  constructor(
        private _appService: appService,
         private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.GetTransporterListHired();
  }
  BiddingDuration: any;
  obj:any={
    BidAmount: '',
    BidDuration: '',
    MaxBidAllowance: 0
  }
  
  BidAmount: any = {
    lable: "Maximum Bid Amount",
    formControlName: "BidAmount",
    dataField: "BidAmount",
    isRequired: false,
    placeholder: "Enter bid amount",
    type:"number"
  };
    BidDuration: any = {
    lable: "Bid Duration",
    formControlName: "BidDuration",
    dataField: "BidDuration",
    isRequired: false,
    isTime: true,
    placeholder: "Enter Date",
  };


  getChangedValue(value,field){
    if(field.dataField == 'BidAmount'){
      this.obj.BidAmount = value;
    }
    if(field.dataField == 'BidDuration'){
      const selectedDate = new Date(value).getTime(); 
      const currentDate = new Date().setHours(0, 0, 0, 0); 
      if(selectedDate < currentDate){
        this.toastr.warning("Please select Current date");
        return;
      }
      this.obj.BidDuration = value
    }
    console.log(this.obj);
  }

   Cancel() {
      this.close.emit(false);
    }


    Save(){
      this.obj.OrderId = this.Orderid;
      console.log('Toggle Value :', this.MaxBidAllowance);
      this._appService.Post("OrdersByVehicle","AddBidDetails",this.obj).subscribe((res: any) => {
        console.log(res);
        this.GetTransporterListHired();
        this.close.emit(true);
        // this.startTimer.emit();
        // window.location.reload();
      }, (err) => {
        this.toastr.error("Error while updating data ",err);
      });
    }


    GetTransporterListHired() {
      this._appService
        .GetById("OrdersByVehicle", "GetBidList",this.Orderid)
        .subscribe(
          (response) => {
            this.MinBidAmount= response[0].MinBidAmount;
            this.BidDurationData = response[0].BidDuration;
            this.obj.BidAmount = response[0].MinBidAmount;
            this.obj.BidDuration = response[0].BidDuration;
            this.BiddingDuration = response[0].BidDuration;

            //added by BURHAN - 28-April-2026
            this.MaxBidAllowance = response[0].MaxBidAllowance || 0;
            this.obj.MaxBidAllowance = this.MaxBidAllowance;
            //end by BURHAN - 28-April-2026
          },
          (err) => {
            console.log(err);
          }
        );
    }

    //added by BURHAN - 28-April-2026
  accessAllClick(event) {
    this.MaxBidAllowance = event ? 1 : 0; // toggle true/false ko 0/1 mein convert
    this.obj.MaxBidAllowance = this.MaxBidAllowance;
  }
  //end by BURHAN - 28-April-2026

}
